import React from 'react'
import { useSelector } from 'react-redux'
import { State } from 'src/store/rootReducers'
import Link from 'next/link'
import { Box, Image } from './styles'

const BoxTeacher: React.FC = () => {
  const module = useSelector((state: State) => state.course.module)

  return module && module.teacher ? (
    <Box>
      <Link
        legacyBehavior
        passHref
        href={`/professor/${module.teacher.slug}`}
      >
        <a>
          <div className="card">
            <Image image={module.teacher.imageUrl}>
              <div />
            </Image>
            <div className="body-card">
              <h3>{module.teacher.name}</h3>
              <span>{module.teacher.occupation}</span>
            </div>
          </div>
        </a>
      </Link>
    </Box>
  ) : null
}

export default React.memo(BoxTeacher)
